/*
 * @Descripttion: 
 * @Author: JoyWang1024@163.com
 * @Date: 
 */
function Dict() {
  this.langs = [{value:"zh-CN", text:"中文"},{value:"en", text:"English"}]
}
export default Dict